<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">MultiChat Servers</a>
    <div class="ms-auto">
      <button class="btn btn-sm btn-success" (click)="purchaseServer()" [disabled]="purchasing">
        {{ purchasing ? 'Processing...' : '+ Purchase Server (RM 200.00)' }}
      </button>
    </div>
  </div>
</nav>
<hr />

<!-- Security Story -->
<div class="container-fluid">
  <div class="card mb-3 border-primary">
    <div class="card-body">
      <h6 class="card-title">&#x1F6E1;&#xFE0F; Why do you need a MultiChat Server?</h6>
      <p class="mb-2">
        Your WhatsApp and Telegram accounts contain sensitive business data. Running them on a shared environment increases the risk of your number being compromised or flagged.
      </p>
      <p class="mb-2">
        A dedicated <strong>MultiChat Server</strong> isolates your messaging channels on a private, secured server &mdash; only you have access. Each server runs with its own IP address and environment.
      </p>
      <p class="mb-0">
        <strong>If your server IP gets flagged or blocked</strong>, simply terminate it and purchase a new one. Your channels will be set up fresh on a clean IP &mdash; no downtime, no risk to your phone number, and no trace back to your previous server. Think of it as a <em>disposable shield</em> for your business communications.
      </p>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="text-center py-3" *ngIf="loading">Loading...</div>

  <div class="alert alert-info" *ngIf="!loading && servers.length === 0">
    No servers yet. Click <strong>+ Purchase Server</strong> to get started.
  </div>

  <div class="table-responsive" *ngIf="servers.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th style="width:40px">#</th>
          <th>IP Address</th>
          <th>Hostname</th>
          <th>Status</th>
          <th>Price</th>
          <th>Created</th>
          <th style="width:180px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of servers; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ s.ip_address || '—' }}</td>
          <td>{{ s.hostname || '—' }}</td>
          <td>
            <span class="badge" [ngClass]="getStatusBadge(s.status)">{{ s.status }}</span>
          </td>
          <td>RM {{ s.price | number:'1.2-2' }}</td>
          <td>{{ s.create_on | date:'dd-MM-yyyy HH:mm' }}</td>
          <td>
            <div class="d-flex gap-1">
              <button class="btn btn-sm btn-outline-info" (click)="checkStatus(s)"
                *ngIf="s.status === 'provisioning' || s.status === 'pending'" title="Refresh status">
                &#x1F504; Check
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="terminateServer(s)"
                *ngIf="s.status !== 'terminated'" title="Terminate server">
                Terminate
              </button>
              <span *ngIf="s.status === 'terminated'" class="text-muted small">Terminated</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
